import {LayoutIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11 10.13-.632-.57L.893 0 0 .901 11 12 22 .901 21.107 0l-9.475 9.56z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(LayoutIcon, {icon: {render}, name: "arrow_down_light"}) } }